
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_930GqRg_45URxZnrbZhQR1HdrptjGhpkIM9RWyzbD3F8irkMeta } from "/app/pages/[slug].vue?macro=true";
import { default as indexawtd3uTwqD2OiTxvw4ItjDaeH0Vj8rNbzlK7PareV_cMeta } from "/app/pages/schools/index.vue?macro=true";
import { default as news_45iAffYcUSvHvdKxlAe35v6d4yfiZZ447RcVXh8Q37zMMeta } from "/app/pages/schools/[schoolId]/news.vue?macro=true";
import { default as indexZMN6JwCke9akYFGcofZEvCi6Eorme7cIDcYCZJSc53kMeta } from "/app/pages/schools/[schoolId]/index.vue?macro=true";
import { default as videosuEKP43Jyc1kHFfrmJFy_45ObQNf6lTv_lDvtkCD1UDBSoMeta } from "/app/pages/schools/[schoolId]/videos.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "schools",
    path: "/schools",
    component: () => import("/app/pages/schools/index.vue")
  },
  {
    name: "schools-schoolId-news",
    path: "/schools/:schoolId()/news",
    component: () => import("/app/pages/schools/[schoolId]/news.vue")
  },
  {
    name: "schools-schoolId",
    path: "/schools/:schoolId()",
    component: () => import("/app/pages/schools/[schoolId]/index.vue")
  },
  {
    name: "schools-schoolId-videos",
    path: "/schools/:schoolId()/videos",
    component: () => import("/app/pages/schools/[schoolId]/videos.vue")
  }
]